import SecurityVerificationForm from './SecurityVerificationForm';

import LoadingLoop from '../../assets/animation-json/SecurityVerificationLoading.json';
import Verified from '../../assets/svg/SuccessfullyVerified.svg';
import PopupMandatoryModel from '../../lib/popupModel/PopupMandatoryModel/PopupMandatoryModel';
import {postAPICall} from '../../services/apiCallsHandler';
import {
  COUNTRY_CONTRACT_LENGTH,
  CUSTOMERID_LENGTH,
  NRStatus,
  SPAIN_COUNTRY_CODE,
  SUPPORTED_COUNTRY_LIST,
  PORTUGAL_COUNTRY_CODE,
  GERMANY_COUNTRY_CODE,
  UK_COUNTRY_CODE,
  cifRegex,
  nieRegex,
  nifRegex,
  nifPortugalRegex,
} from '../../utils/constant';
import {sendCustomDataNR} from '../../utils/util';

import Lottie from 'lottie-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import './SecurityVerification.css';

const SecurityVerification = (props) => {
  const [contract, setContract] = React.useState('');
  const [contractErrorMsg, setContractErrorMsg] = React.useState('');
  const [uniqueId, setUniqueId] = React.useState('');
  const [customerId, setCustomerId] = React.useState('');
  const [uniqueIdErrorMsg, setUniqueIdErrorMsg] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [firstNameErrorMsg, setFirstNameErrorMsg] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [lastNameErrorMsg, setLastNameErrorMsg] = React.useState('');
  const [alert, setAlert] = React.useState(false);
  const [disableBtn, setDisableBtn] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [maskedEmail, setMaskedEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [verified, setVerified] = React.useState(false);
  const [isWrongCountry, setIsWrongCountry] = React.useState(false);
  const [currentFormStep, setCurrentFormStep] = React.useState(1);
  const [selectedCountry, setSelectedCountry] = React.useState(
    localStorage.getItem('countryCode')
      ? localStorage.getItem('countryCode')
      : 'gb'
  );

  const {t, i18n} = useTranslation();
  const navigate = useNavigate();
  const NR_ACTION = 'SecurityVerification';

  React.useEffect(() => {
    i18n.changeLanguage(selectedCountry);
  }, [selectedCountry]);

  const countryContractLength = COUNTRY_CONTRACT_LENGTH[selectedCountry];
  const handleValueChange = (val, field) => {
    if (field == 'contract') {
      setContract(val);
      let errorMsg = '';
      if (val.length === 0) {
        errorMsg = 'CONTRACT_NUMBER_REQUIRED';
      } else if (val.length !== countryContractLength) {
        errorMsg = 'CONTRACT_NUMBER_SIX_DIGIT';
      }
      setContractErrorMsg(errorMsg);
    } else if (field == 'uniqueId') {
      const cleaned = setUniqueInFormat(val);
      let errorMsg = '';

      if (selectedCountry === SPAIN_COUNTRY_CODE) {
        if (
          cleaned.length > 0 &&
          !(
            cifRegex.test(cleaned) ||
            nifRegex.test(cleaned) ||
            nieRegex.test(cleaned)
          )
        ) {
          errorMsg = 'UNIQUE_ID_CORRECT';
        }
      } else if (selectedCountry === PORTUGAL_COUNTRY_CODE) {
        if (cleaned.length > 0 && !nifPortugalRegex.test(cleaned)) {
          errorMsg = 'UNIQUE_ID_CORRECT';
        }
      } else if (cleaned.length === 0) {
        errorMsg = 'UNIQUE_ID_REQUIRED';
      } else if (cleaned.length !== CUSTOMERID_LENGTH) {
        errorMsg = 'UNIQUE_ID_CORRECT';
      }
      setUniqueIdErrorMsg(errorMsg);
    } else if (field == 'firstName') {
      setFirstName(val);
      setFirstNameErrorMsg(val.length === 0 ? 'FIRST_NAME_REQUIRED' : '');
    } else if (field == 'lastName') {
      setLastName(val);
      setLastNameErrorMsg(val.length === 0 ? 'LAST_NAME_REQUIRED' : '');
    }
  };
  const formFields = [
    {
      label: 'SEC_CONTRACT_NUMBER',
      type: 'number',
      required: true,
      id: 'contractNumber',
      value: contract,
      setValue: (val) => handleValueChange(val, 'contract'),
      error: contractErrorMsg !== '',
      helperText: contractErrorMsg,
      infoIconText: t('CONTRACT_NO_TOOLTIP_MSG'),
      isHidden: false,
      step: 1,
    },
    {
      label: `UNIQUE_ID`,
      type: 'text',
      required: true,
      id: 'uniqueId',
      value: uniqueId,
      setValue: (val) => handleValueChange(val, 'uniqueId'),
      error: uniqueIdErrorMsg !== '',
      helperText: uniqueIdErrorMsg,
      infoIconText: t('CUSTOMERID_TOOLTIP_MSG'),
      isHidden: false,
      step: 1,
    },
    {
      label: 'FIRST_NAME',
      type: 'text',
      required: true,
      id: 'firstName',
      value: firstName,
      setValue: (val) => handleValueChange(val, 'firstName'),
      error: firstNameErrorMsg !== '',
      helperText: firstNameErrorMsg,
      isHidden: false,
      step: 2,
    },
    {
      label: 'LAST_NAME',
      type: 'text',
      required: true,
      id: 'lastName',
      value: lastName,
      setValue: (val) => handleValueChange(val, 'lastName'),
      error: lastNameErrorMsg !== '',
      helperText: lastNameErrorMsg,
      isHidden: false,
      step: 2,
    },
  ];

  function setUniqueInFormat(e) {
    let cleanedValue;
    if (
      selectedCountry === SPAIN_COUNTRY_CODE ||
      selectedCountry === PORTUGAL_COUNTRY_CODE
    ) {
      // Spain and Portugal - handles tax IDs with letters
      cleanedValue = e.replaceAll(/[^A-Za-z0-9]/g, '');
      // For Portugal
      if (
        selectedCountry === PORTUGAL_COUNTRY_CODE &&
        cleanedValue.length > 9
      ) {
        cleanedValue = cleanedValue.substring(0, 9);
      }
    } else {
      cleanedValue = e.replaceAll(/[\D]/g, '');
      if (cleanedValue.length > CUSTOMERID_LENGTH) {
        cleanedValue = cleanedValue.substring(0, CUSTOMERID_LENGTH);
      }
    }

    const finalValue = cleanedValue.replaceAll(/[A-Za-z]/g, (match) =>
      match.toUpperCase()
    );
    setUniqueId(finalValue);
    return finalValue;
  }

  const showFAQMenu = () => {
    navigate('/faq', {
      state: {
        selectedCountry: selectedCountry,
        returnPath: '/verification',
      },
    });
  };

  const forgotUniqueID = () => {
    sendCustomDataNR(
      'FetchCustomerID',
      sessionStorage.getItem('trace-id'),
      localStorage.getItem('countryCode'),
      null,
      'FetchCustomerID_Clicked'
    );
    navigate('/get-customer-id', {
      state: {
        selectedCountry: selectedCountry,
        returnPath: '/verification',
      },
    });
  };

  const handleSubmit = async () => {
    let reqBody = {};
    if (currentFormStep == 1) {
      reqBody.contract = contract;
      reqBody.uniqueId = uniqueId;
      reqBody.isCustomerId =
        selectedCountry !== SPAIN_COUNTRY_CODE &&
        selectedCountry !== PORTUGAL_COUNTRY_CODE;
    } else {
      reqBody.firstName = firstName;
      reqBody.lastName = lastName;
      reqBody.isCustomerId =
        selectedCountry !== SPAIN_COUNTRY_CODE &&
        selectedCountry !== PORTUGAL_COUNTRY_CODE;
      reqBody.uniqueId = uniqueId;
    }
    reqBody.countryCode = selectedCountry;
    reqBody.currentFormStep = currentFormStep;
    setDisableBtn(true);
    setLoading(true);
    await postAPICall(
      props.unsecure ? 'verification' : 'securityVerification',
      {...reqBody},
      {
        isCallBack: false,
        errorTag: 'POST_SECURITY_VERIFICATION',
        redirectToOops: false,
      }
    ).then((res) => {
      let errorMessageNR = '';
      setDisableBtn(false);
      setLoading(false);
      if (res.status === 200) {
        setAlert(false);
        if (currentFormStep == 1) {
          sendCustomDataNR(
            NR_ACTION,
            sessionStorage.getItem('trace-id'),
            localStorage.getItem('countryCode'),
            null,
            NRStatus.successStep1,
            res?.body?.custId,
            res?.body?.uniqueId
          );
          setCustomerId(res?.body?.custId);
          if (
            props.unsecure &&
            res.body?.registrationURL &&
            res.body?.registrationURL !== ''
          ) {
            //Add redirection to My JD account creation screen
            setTimeout(() => {
              globalThis.location.href = res.body.registrationURL;
            }, 2000);
          } else {
            setCurrentFormStep(2);
          }
        } else {
          sendCustomDataNR(
            NR_ACTION,
            sessionStorage.getItem('trace-id'),
            localStorage.getItem('countryCode'),
            null,
            NRStatus.successStep2,
            res?.body?.custId,
            res?.body?.uniqueId
          );
          setVerified(true);
          if (props.unsecure) {
            //Add redirection to My JD account creation screen
            setTimeout(() => {
              if (res.body?.registrationURL !== '') {
                globalThis.location.href = res.body.registrationURL;
              }
            }, 2000);
          }
        }
      } else {
        setDisableBtn(false);
        if (/^(5\d{2})/.test(res.status)) {
          setErrorMessage(t('SOMETHING_WENT_WRONG_TRY_AGAIN'));
          errorMessageNR = 'Something went wrong.';
        } else {
          setErrorMessage(res.body.message);
          setMaskedEmail(res.body.maskedEmail || '');
          errorMessageNR = res.body;
          if (
            currentFormStep == 2 &&
            res.body.message == 'TIMEOUT_ERROR_MESSAGE'
          ) {
            setCurrentFormStep(1);
          }
        }
        sendCustomDataNR(
          NR_ACTION,
          sessionStorage.getItem('trace-id'),
          localStorage.getItem('countryCode'),
          errorMessageNR,
          NRStatus['failedStep' + currentFormStep],
          res?.body?.custId,
          res?.body?.uniqueId
        );
        setAlert(true);
      }
    });
  };

  React.useEffect(() => {
    if (
      uniqueId.length > 0 &&
      ((selectedCountry === SPAIN_COUNTRY_CODE &&
        contract.length === 6 &&
        (cifRegex.test(uniqueId) ||
          nifRegex.test(uniqueId) ||
          nieRegex.test(uniqueId))) ||
        (selectedCountry === PORTUGAL_COUNTRY_CODE &&
          contract.length === 6 &&
          nifPortugalRegex.test(uniqueId)) ||
        (selectedCountry === UK_COUNTRY_CODE &&
          contract.length === 8 &&
          uniqueId.length === CUSTOMERID_LENGTH) ||
        (selectedCountry === GERMANY_COUNTRY_CODE &&
          contract.length === 7 &&
          uniqueId.length === CUSTOMERID_LENGTH))
    ) {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [contract, uniqueId]);

  React.useEffect(() => {
    if (firstName.length > 0 && lastName.length > 0) {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [firstName, lastName]);

  React.useEffect(() => {
    if (!props.unsecure) {
      setIsWrongCountry(
        !SUPPORTED_COUNTRY_LIST.includes(
          props.userDetails?.country.toLowerCase()
        )
      );
    }
  }, [props.userDetails]);

  const countryChangeHandler = (value) => {
    setSelectedCountry(value);
    setAlert(false);
    if (currentFormStep == 1) {
      setContract('');
      setUniqueInFormat('');
    }
  };
  const VerifiedSuccessfully = (successAction, t) => {
    setTimeout(() => successAction(customerId), 3000);
    return (
      <div className="Sec-verified-wrapper">
        <div className="sec-verified-container">
          <div>
            <img src={Verified} alt="Successfully Verified" />
          </div>
          <h2>{t('SUCCESSFULLY_VERIFIED')}</h2>
          <p>{t('ACCOUNT_VERIFIED_SUCCESSFULLY_TEXT')}</p>
        </div>
      </div>
    );
  };

  const verifiedComponent = (successAction, t) => {
    return (
      <>
        {verified ? (
          VerifiedSuccessfully(successAction, t)
        ) : (
          <SecurityVerificationForm
            errorMessage={errorMessage}
            maskedEmail={maskedEmail}
            alert={alert}
            formFields={formFields}
            handleSubmit={handleSubmit}
            disableBtn={disableBtn}
            countryChangeHandler={countryChangeHandler}
            currentFormStep={currentFormStep}
            loading={loading}
            showFAQMenu={showFAQMenu}
            forgotUniqueID={forgotUniqueID}
            selectedCountry={selectedCountry}
            unsecureRoute={props.unsecure}
            closeAlreadyMappedPopup={() => setAlert(false)}
          />
        )}
      </>
    );
  };

  return (
    <div
      className="securityVerificationForm"
      data-testid="securityVerificationForm"
    >
      <div
        className={'SecurityVerificationWrapper'}
        data-testid={'SecurityVerificationWrapper'}
        id="center-content"
      >
        {loading && currentFormStep == 2 ? (
          <div className="loading-animation-sec-ver">
            <div className="svg-animation">
              <Lottie animationData={LoadingLoop} loop={true} />
            </div>
            <p>{t('SECURITY_VERIFICATION_LOADER_TEXT')}</p>
          </div>
        ) : (
          verifiedComponent(props.successAction, t)
        )}
      </div>
      {isWrongCountry ? (
        <PopupMandatoryModel
          title={t('WRONG_COUNTRY_TITLE')}
          description={t('WRONG_COUNTRY_DESC')}
          hrefLink={
            import.meta.env.VITE_MANAGE_PROFILE_LINK +
            'signOut?isRedirected=true'
          }
          hrefDesc={t('EDIT_PROFILE')}
        />
      ) : null}
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    userDetails: state.appStates.userDetailsInfo,
  };
};
export default connect(mapStateToProps)(SecurityVerification);
